<template>
<modal-dialog
	:modal-visible="visible"
	:title="title"
	:confirm-button-text="confirmButtonText ? confirmButtonText : 'Add'"
	v-on:confirm="confirmAdd"
	v-on:closeModal="$emit('closeModal')">

	<form-group label="Type" col-class="col-md-4">

		<equipment-type-picker :value="payload"
			:no-text-field="!allowManualType"
			v-on:input="setEquipment">
		</equipment-type-picker>
		
	</form-group>

	<field label="Rate Unit"
		col-class="col-md-4"
		:params="{
			type:'select',
			options: [
				{text: 'Hourly',value:'hour'},
				{text: 'Daily',value:'day'},
				{text: 'Weekly',value:'week'},
				{text: 'Monthly',value:'month'}
			]
		}"
		v-model="payload.unit"
		v-on:change="rateUnitChange">
	</field>

	<field :label="'Rate ($/' + payload.unit + ')'" 
		col-class="col-md-4" 
		:params="{type:'number',min:0,step:0.01}" 
		v-model="payload.rate">
	</field>

	<field :label="qtyLabel" 	
		col-class="col-md-4" 
		:params="{type:'number',min:0,step:0.25}" 
		v-model="payload.qty">
	</field>

	<slot></slot>

</modal-dialog>
</template>
<script type="text/javascript">

import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"

import EquipmentTypePicker from "@/components/super_components/EquipmentTypePicker"

export default {
	name: "EquipmentTypePickerModal",
	components: {
		ModalDialog,
		Field,
		FormGroup,
		EquipmentTypePicker
	},
	props: [
		"visible",
		"title",
		"record",
		"allowManualType",
		"confirmButtonText"
	],
	data() {
		return {
			payload: {
				typeName: null,
				rate: null,
				hrs: null,
				unit: null,
				equipment_type_id: null,
				multiRates: {}
			},
			equipmentTypes: [],
			manualSelection: false
		}
	},
	watch: {
		visible() {
			if (this.visible) {
				this.fetchData()

				this.setEquipment(this.record)
			}
		},
		record() {
			if (this.record) {
				this.setEquipment(this.record)
			}
		}
	},
	computed: {
		qtyLabel() {
			if (this.payload.unit)
				return this.payload.unit.charAt(0).toUpperCase() + this.payload.unit.slice(1) + "s"

			return "Hours"
		}
	},
	methods: {
		setEquipment(eqObj) {	
			this.payload.typeName = eqObj.type_name
			
			this.payload.equipment_type_id = eqObj.type_id

			this.payload.qty = eqObj.qty

			let rate = ""

			console.log(eqObj)

			if ("multiRates" in eqObj && eqObj.multiRates) {
				//find and set the first active rate
				let activeRateKey = Object.keys(eqObj.multiRates).find(key => eqObj.multiRates[key].enabled)

				if (activeRateKey) {

					if (+this.payload.rate == 0)
						rate = eqObj.multiRates[activeRateKey].rate
					else
						rate = this.payload.rate

					if (!this.payload.unit)
						this.payload.unit = activeRateKey
				}
				else {
					rate = eqObj.rate

					if (!("unit" in this.payload) || !this.payload.unit)
						this.payload.unit = eqObj.unit

					if (this.payload.unit == 'hrs')
						this.payload.unit = "hour"
				}

				this.payload.multiRates = eqObj.multiRates
			}
			else if ("rate" in eqObj)
				rate = eqObj.rate

			if (!("unit" in this.payload) || !this.payload.unit)
				this.payload.unit = eqObj.unit

			if (this.payload.unit == 'hrs' || !this.payload.unit)
				this.payload.unit = "hour"

			if (rate && typeof rate == 'string')
				rate = rate.replace(",","")
			
			rate = +rate
			rate = rate.toFixed(2)

			this.payload.rate = rate

			if (eqObj && "rate" in eqObj && !this.payload.rate)
				this.payload.rate = eqObj.rate
		},
		confirmAdd() {
			this.$emit("confirmAdd",this.payload)
		},
		rateUnitChange(unit) {
			//populate the rate

			if ("multiRates" in this.payload && this.payload.multiRates && unit in this.payload.multiRates) {
				let selectedRate = this.payload.multiRates[unit]

				if (selectedRate && selectedRate.enabled) {
					let selectedRateValue = +selectedRate.rate

					this.payload.rate = selectedRateValue.toFixed(2)
				}
				else
					this.payload.rate = 0
			}

			else if ("charge_out_rates_json" in this.payload && this.payload.charge_out_rates_json) {
				try {

					let multiRates = JSON.parse(this.payload.charge_out_rates_json)

					let rate = 0
					if (unit in multiRates) {
						rate = +multiRates[unit].rate

						this.payload.rate = rate.toFixed(2)
					}
				}
				catch (e) {

				}
			}

			this.payload.qty_unit = unit
		},
		fetchData() {
			let vm = this

			let promises = [
				this.getJSON("EquipmentType/get")
			]

			Promise.all(promises).then(responses => {
				if (responses[0].success) {
					vm.equipmentTypes = responses[0].data
				}
			})
		}
	},
	created() {
		if (this.visible) {
			this.fetchData()
			this.setEquipment(this.record)
		}
	}
}
</script>